import { CSS as MenuItemCSS } from '../../../components/menu/menu.item.style';
import { DefaultTheme } from '../../../components/theme';
import { IkeCssUtil } from '../../../components/theme.util';

export const CSS = {
	container: 'c-FormEditFieldInfo',
	section: {
		container: 'c-FormEditFieldInfo__section',
		final: 'c-FormEditFieldInfo__section--final',
	},
	move: 'c-FormEditFieldInfo__move',
	title: 'c-FormEditFieldInfo__title',
	type: 'c-FormEditFieldInfo__type',
	menu: 'c-FormEditFieldInfo__menu',
	input: {
		container: 'c-FormEditFieldInfo__input',
		title: 'c-FormEditFieldInfo__inputTitle',
		value: 'c-FormEditFieldInfo__inputValue',
	},
	option: 'c-FormEditFieldInfo__option',
	optionButton: 'c-FormEditFieldInfo__optionButton',
	isOptionActive: 'c-FormEditFieldInfo__option--is-active',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		'flex-direction': 'column',
		...IkeCssUtil.padding(1, 8),
		position: 'relative',
	},
	[CSS.section.container]: {
		display: 'flex',
		'align-items': 'center',
	},
	[CSS.section.final]: {
		'margin-bottom': DefaultTheme.space(8),
		'flex-wrap': 'wrap',
	},
	[CSS.menu]: {
		[`& .${MenuItemCSS.item}`]: {
			'padding-top': DefaultTheme.space(1),
			'padding-bottom': DefaultTheme.space(1),
			'line-height': DefaultTheme.space(6),
		},
	},
	[CSS.title]: IkeCssUtil.Flex.centerVertical,
	[CSS.type]: {
		'align-items': 'center',
		'& > i': {
			margin: `0 ${DefaultTheme.space(1)}`,
		},
	},
	[CSS.option]: {
		...IkeCssUtil.Flex.centerVertical,
		height: DefaultTheme.space(8),
	},
	[CSS.input.container]: {
		'margin-right': DefaultTheme.space(4),
		height: DefaultTheme.space(8),
		display: 'flex',
		cursor: 'default',
	},
	[CSS.option]: {
		...IkeCssUtil.Flex.centerVertical,
		height: DefaultTheme.space(8),
	},
	[CSS.input.value]: {
		...IkeCssUtil.Flex.centerVertical,
		height: DefaultTheme.space(8),
	},
	[CSS.input.title]: {
		...IkeCssUtil.Flex.centerVertical,
		'margin-right': DefaultTheme.space(2),
		'font-weight': 'bold',
		overflow: 'hidden',
	},
	[CSS.move]: {
		...IkeCssUtil.absolute(2, 1),
		...IkeCssUtil.Flex.column,
		width: DefaultTheme.space(8),
	},
};
